import { Component } from '@angular/core';
import { ToastModule } from '@openng/optimus-ui/toast';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [ToastModule, RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class AppComponent {}
